import axios from "axios";

const API_URL = import.meta.env.VITE_API_URL || "https://dashboard.lono.co.in/api";

// Create axios instance with base URL
const api = axios.create({
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
  },
});

// Add a request interceptor to include the token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// evaluation API
export const evaluationAPI = {
  // ✅ Evaluation Board APIs (NEW)
  saveEvaluationData: async (loanId, customerId, data) => {
    try {
      const payload = { loanId, customerId, data };
      const response = await api.post("/evaluation/save", payload);
      return response.data;
    } catch (error) {
      console.error("Error saving evaluation data:", error);
      throw error.response?.data || error.message;
    }
  },

  getEvaluationByLoanId: async (loanId) => {
    try {
      const response = await api.get(`/evaluation/${loanId}`);
      return response.data;
    } catch (error) {
      console.error("Error fetching evaluation data:", error);
      throw error.response?.data || error.message;
    }
  },
};
